module.exports = __webpack_public_path__ + "img/grey_024.ed4891b7.png";